import {
  Text,
  TextInput,
  TextArea,
  RemoteSelect,
  Tag,
  Time,
  Select,
  TimeSelect,
  AddressSelect,
  StockGroupSelect,
  HoldTag,
  HoldSelect,
  TimeRange,
  EditFormItemTypes,
  NumberInput,
  FormModes,
  TimeLocalDate,
  TimeLocalTime,
  TimeFormat,
  SlotType,
  Blank,
  Checkbox,
  RadioGroup,
  PrependSelect,
  PrependText
} from '@/core/configs/types'

export const FormTypeMixin = {
  data: function () {
    return {
      Text,
      TextInput,
      TextArea,
      RemoteSelect,
      Tag,
      Select,
      Time,
      TimeSelect,
      AddressSelect,
      TimeRange,
      NumberInput,
      EditFormItemTypes,
      FormModes,
      SlotType,
      TimeLocalDate,
      TimeLocalTime,
      TimeFormat,
      Blank,
      Checkbox,
      RadioGroup,
      PrependSelect,
      PrependText,
      HoldTag,
      HoldSelect,
      StockGroupSelect
    }
  },
  methods: {
    isEditType(type) {
      return this.EditFormItemTypes.includes(type)
    }
  }
}
